import styled from 'styled-components';
const ImportStyled = styled.div`
  position: relative;
  .MuiInput-root {
    border: 1px solid red;
    width: 108px;
    height: 40px;
    opacity: 0;
    position: absolute;
    z-index: 20;
    top: 0;
    left: 0;
  }
`;
export default ImportStyled;
